import { useState, type JSX } from 'react';
import { Link } from 'react-router';

import styles from './styles.module.css';

export function ProviderFooter(): JSX.Element {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <footer className={styles.footer}>
      <div className={styles.wrap}>
        <div className={styles.footerCols}>
          <div>
            <Link
              to="/"
              className={`${styles.logo} ${styles.footerLogo}`}
              aria-label="NourishedRx home"
            >
              {logoFailed ? (
                <span className={styles.logoText}>NourishedRx</span>
              ) : (
                <img src="/logo.png" alt="NourishedRx" onError={() => setLogoFailed(true)} />
              )}
            </Link>
            <p className={styles.footerAbout}>
              A digital nutrition program for Medicare beneficiaries, delivered through the ACCESS
              program.
            </p>
            <p className={styles.footerContact}>
              Questions about referring?
              <br />
              <a href="mailto:access@nourishedrx.com">access@nourishedrx.com</a>
            </p>
          </div>
          <div>
            <h5>For Providers</h5>
            <ul>
              <li>
                <Link to="/refer">Submit a referral</Link>
              </li>
              <li>
                <a href="#how">How it works</a>
              </li>
              <li>
                <a href="#coordination">Care coordination</a>
              </li>
              <li>
                <a href="#faqs">FAQs</a>
              </li>
            </ul>
          </div>
          <div>
            <h5>For Members</h5>
            <ul>
              <li>
                <Link to="/#beneficiary">How to enroll</Link>
              </li>
              <li>
                <Link to="/#beneficiary">Tell your provider</Link>
              </li>
              <li>
                <Link to="/#what">About the program</Link>
              </li>
            </ul>
          </div>
          <div>
            <h5>Program</h5>
            <ul>
              <li>
                <Link to="/">Overview</Link>
              </li>
              <li>
                {/* placeholder — URL TBD */}
                <a href="#">Food Partners</a>
              </li>
              <li>
                {/* placeholder — URL TBD */}
                <a href="#">Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.footerLegal}>
          <span>NourishedRx © 2026 · All Rights Reserved.</span>
          <a href="#">Terms &amp; Conditions</a>
          <a href="#">Privacy Policy</a>
          <span className={styles.legalFaint}>
            A covered benefit administered through the Medicare ACCESS program.
          </span>
        </div>
      </div>
    </footer>
  );
}
